import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=13621b95&scoped=true"
import script from "./AdBanner.vue?vue&type=script&lang=js"
export * from "./AdBanner.vue?vue&type=script&lang=js"
import style0 from "./AdBanner.vue?vue&type=style&index=0&id=13621b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13621b95",
  null
  
)

export default component.exports